import React from 'react';
import { routes } from 'routes';

import { AppBarContext } from 'components/AppBar/AppBarContext';
import { ImageLoader } from 'components/Icons/ImageLoader';
import { AppBarHeader } from 'components/AppBar/Header/AppBarHeader';

import { isPublicRoute } from 'utils/routes';
import { redirectToPath } from 'utils/util';

export const AppBar = ({ title, appBarProps }) => {
  const {
    appMenuHidden,
    tenantSettings: { logo }
  } = appBarProps;

  const onCLickLogoRedirectToRoute = isPublicRoute()
    ? routes.oldBankSelection.path
    : routes.overview.path;

  const appLogo = (
    <React.Fragment>
      {!appMenuHidden ? (
        <button
          className="flex items-center justify-center border-0"
          type="button"
          onClick={() => redirectToPath(onCLickLogoRedirectToRoute)}
        >
          <ImageLoader
            src={logo}
            style={{
              height: '30px',
              maxWidth: '200px',
              width: 'auto',
              cursor: 'pointer',
              objectFit: 'contain'
            }}
            isWithFallback={false}
          />
        </button>
      ) : (
        <button
          className="w-full text-center"
          type="button"
          onClick={() => redirectToPath(onCLickLogoRedirectToRoute)}
        >
          {title}
        </button>
      )}
    </React.Fragment>
  );

  return (
    <AppBarContext.Provider value={appBarProps}>
      <AppBarHeader logoComponent={appLogo} />
    </AppBarContext.Provider>
  );
};
